import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import { ensureFlightRecordAircraftColorHelpers } from "./lib/aircraft_chart_colors"

ensureFlightRecordAircraftColorHelpers()
